"use strict";

const values = [
  {
    label: "Pathology study",
    code: "11526-1"
  },
  {
    label: "Diagnostic imaging study",
    code: "18748-4"
  },
  {
    label: "Laboratory report",
    code: "11502-2"
  }
];

const makeItem = (val) => {
  return {
    value: {
      system: "http://snomed.info/sct",
      display: val.label,
      code: val.code
    },
    label: val.label,
    category: val.label
  };
};

module.exports = values.map(makeItem);
